import { formatDate } from "../../utils/date";

export type NotificationHistoryStatus = "PENDING" | "FAILED" | "SENT";

export type NotificationHistoryItem = {
  type: string;
  description: string;
  triggerId: string;
  sentDate: string;
  status: string;
  fileURN?: string;
  sentTime: string;
};

export function notificationHistoryItemTransformer(row: any): NotificationHistoryItem {
  return {
    type: row.notifyType,
    description: row.description,
    triggerId: row.triggerId,
    sentDate: row.notifySentDate + "",
    sentTime: `0${row.notificationSentTime}`.slice(-6),
    status: row.notificationStatusCode,
    fileURN: row.fileUrn
  };
}

export type NotificationSendPayload = {
  type: string;
  notificationText?: string;
}

export type NotificationPreviewResponse = {
  notfnUrn: string;
  notificationBase64: string;
  subNarrative_base64: string;
  subject: string;
  triggerId: string;
}

export type NotificationEditionPayload = {
  status: "READY",
  subNarrative_base64: string;
  subject: string;
  notfnUrn: string;
  triggerId: string;
}
